/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as UnauthorizedRouteImport } from './routes/unauthorized'
import { Route as LoginRouteImport } from './routes/login'
import { Route as DashboardRouteRouteImport } from './routes/_dashboard/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ShowcaseIndexRouteImport } from './routes/showcase/index'
import { Route as DashboardParticipationsRouteRouteImport } from './routes/_dashboard/participations/route'
import { Route as DashboardModulesRouteRouteImport } from './routes/_dashboard/modules/route'
import { Route as DashboardHrdRouteRouteImport } from './routes/_dashboard/hrd/route'
import { Route as DashboardCampaignsRouteRouteImport } from './routes/_dashboard/campaigns/route'
import { Route as PublicResetPasswordIndexRouteImport } from './routes/_public/reset-password/index'
import { Route as PublicForgotPasswordIndexRouteImport } from './routes/_public/forgot-password/index'
import { Route as DashboardParticipationsIndexRouteImport } from './routes/_dashboard/participations/index'
import { Route as DashboardParticipationsLaboratoireIndexRouteImport } from './routes/_dashboard/participations-laboratoire/index'
import { Route as DashboardModulesIndexRouteImport } from './routes/_dashboard/modules/index'
import { Route as DashboardCertificatsIndexRouteImport } from './routes/_dashboard/certificats/index'
import { Route as DashboardCampaignsIndexRouteImport } from './routes/_dashboard/campaigns/index'
import { Route as DashboardAnnuaireIndexRouteImport } from './routes/_dashboard/annuaire/index'
import { Route as DashboardPreferencesProgramsRouteImport } from './routes/_dashboard/preferences/programs'
import { Route as DashboardPreferencesFlagsRouteImport } from './routes/_dashboard/preferences/flags'
import { Route as DashboardHrdLaboratoriesRouteImport } from './routes/_dashboard/hrd/laboratories'
import { Route as DashboardAnnuaireTabRouteImport } from './routes/_dashboard/annuaire/$tab'
import { Route as DashboardParticipationsUuidRouteRouteImport } from './routes/_dashboard/participations/$uuid/route'
import { Route as DashboardModulesUuidRouteRouteImport } from './routes/_dashboard/modules/$uuid/route'
import { Route as DashboardHrdFormulairesRouteRouteImport } from './routes/_dashboard/hrd/formulaires/route'
import { Route as DashboardCampaignsUuidRouteRouteImport } from './routes/_dashboard/campaigns/$uuid/route'
import { Route as DashboardParticipationsUuidIndexRouteImport } from './routes/_dashboard/participations/$uuid/index'
import { Route as DashboardHrdFormulairesIndexRouteImport } from './routes/_dashboard/hrd/formulaires/index'
import { Route as DashboardHrdCasIndexRouteImport } from './routes/_dashboard/hrd/cas/index'
import { Route as DashboardParticipationsUuidTabRouteImport } from './routes/_dashboard/participations/$uuid/$tab'
import { Route as DashboardModulesUuidTabRouteImport } from './routes/_dashboard/modules/$uuid/$tab'
import { Route as DashboardHrdCasUuidRouteImport } from './routes/_dashboard/hrd/cas/$uuid'
import { Route as DashboardCampaignsUuidTabRouteImport } from './routes/_dashboard/campaigns/$uuid/$tab'
import { Route as DashboardAnnuairePeopleUuidRouteImport } from './routes/_dashboard/annuaire/people.$uuid'
import { Route as DashboardAnnuaireOrganizationsUuidRouteImport } from './routes/_dashboard/annuaire/organizations.$uuid'
import { Route as DashboardHrdFormulairesUuidRouteRouteImport } from './routes/_dashboard/hrd/formulaires/$uuid/route'
import { Route as DashboardHrdFormulairesUuidTabRouteImport } from './routes/_dashboard/hrd/formulaires/$uuid/$tab'
import { Route as DashboardModulesUuidParticipationsParticipationUuidRouteRouteImport } from './routes/_dashboard/modules/$uuid/participations/$participationUuid/route'

const UnauthorizedRoute = UnauthorizedRouteImport.update({
  id: '/unauthorized',
  path: '/unauthorized',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardRouteRoute = DashboardRouteRouteImport.update({
  id: '/_dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const ShowcaseIndexRoute = ShowcaseIndexRouteImport.update({
  id: '/showcase/',
  path: '/showcase/',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardParticipationsRouteRoute =
  DashboardParticipationsRouteRouteImport.update({
    id: '/participations',
    path: '/participations',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardModulesRouteRoute = DashboardModulesRouteRouteImport.update({
  id: '/modules',
  path: '/modules',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardHrdRouteRoute = DashboardHrdRouteRouteImport.update({
  id: '/hrd',
  path: '/hrd',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardCampaignsRouteRoute = DashboardCampaignsRouteRouteImport.update({
  id: '/campaigns',
  path: '/campaigns',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const PublicResetPasswordIndexRoute =
  PublicResetPasswordIndexRouteImport.update({
    id: '/_public/reset-password/',
    path: '/reset-password/',
    getParentRoute: () => rootRouteImport,
  } as any)
const PublicForgotPasswordIndexRoute =
  PublicForgotPasswordIndexRouteImport.update({
    id: '/_public/forgot-password/',
    path: '/forgot-password/',
    getParentRoute: () => rootRouteImport,
  } as any)
const DashboardParticipationsIndexRoute =
  DashboardParticipationsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DashboardParticipationsRouteRoute,
  } as any)
const DashboardParticipationsLaboratoireIndexRoute =
  DashboardParticipationsLaboratoireIndexRouteImport.update({
    id: '/participations-laboratoire/',
    path: '/participations-laboratoire/',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardModulesIndexRoute = DashboardModulesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DashboardModulesRouteRoute,
} as any)
const DashboardCertificatsIndexRoute =
  DashboardCertificatsIndexRouteImport.update({
    id: '/certificats/',
    path: '/certificats/',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardCampaignsIndexRoute = DashboardCampaignsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DashboardCampaignsRouteRoute,
} as any)
const DashboardAnnuaireIndexRoute = DashboardAnnuaireIndexRouteImport.update({
  id: '/annuaire/',
  path: '/annuaire/',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardPreferencesProgramsRoute =
  DashboardPreferencesProgramsRouteImport.update({
    id: '/preferences/programs',
    path: '/preferences/programs',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardPreferencesFlagsRoute =
  DashboardPreferencesFlagsRouteImport.update({
    id: '/preferences/flags',
    path: '/preferences/flags',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardHrdLaboratoriesRoute =
  DashboardHrdLaboratoriesRouteImport.update({
    id: '/laboratories',
    path: '/laboratories',
    getParentRoute: () => DashboardHrdRouteRoute,
  } as any)
const DashboardAnnuaireTabRoute = DashboardAnnuaireTabRouteImport.update({
  id: '/annuaire/$tab',
  path: '/annuaire/$tab',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardParticipationsUuidRouteRoute =
  DashboardParticipationsUuidRouteRouteImport.update({
    id: '/$uuid',
    path: '/$uuid',
    getParentRoute: () => DashboardParticipationsRouteRoute,
  } as any)
const DashboardModulesUuidRouteRoute =
  DashboardModulesUuidRouteRouteImport.update({
    id: '/$uuid',
    path: '/$uuid',
    getParentRoute: () => DashboardModulesRouteRoute,
  } as any)
const DashboardHrdFormulairesRouteRoute =
  DashboardHrdFormulairesRouteRouteImport.update({
    id: '/formulaires',
    path: '/formulaires',
    getParentRoute: () => DashboardHrdRouteRoute,
  } as any)
const DashboardCampaignsUuidRouteRoute =
  DashboardCampaignsUuidRouteRouteImport.update({
    id: '/$uuid',
    path: '/$uuid',
    getParentRoute: () => DashboardCampaignsRouteRoute,
  } as any)
const DashboardParticipationsUuidIndexRoute =
  DashboardParticipationsUuidIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DashboardParticipationsUuidRouteRoute,
  } as any)
const DashboardHrdFormulairesIndexRoute =
  DashboardHrdFormulairesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DashboardHrdFormulairesRouteRoute,
  } as any)
const DashboardHrdCasIndexRoute = DashboardHrdCasIndexRouteImport.update({
  id: '/cas/',
  path: '/cas/',
  getParentRoute: () => DashboardHrdRouteRoute,
} as any)
const DashboardParticipationsUuidTabRoute =
  DashboardParticipationsUuidTabRouteImport.update({
    id: '/$tab',
    path: '/$tab',
    getParentRoute: () => DashboardParticipationsUuidRouteRoute,
  } as any)
const DashboardModulesUuidTabRoute = DashboardModulesUuidTabRouteImport.update({
  id: '/$tab',
  path: '/$tab',
  getParentRoute: () => DashboardModulesUuidRouteRoute,
} as any)
const DashboardHrdCasUuidRoute = DashboardHrdCasUuidRouteImport.update({
  id: '/cas/$uuid',
  path: '/cas/$uuid',
  getParentRoute: () => DashboardHrdRouteRoute,
} as any)
const DashboardCampaignsUuidTabRoute =
  DashboardCampaignsUuidTabRouteImport.update({
    id: '/$tab',
    path: '/$tab',
    getParentRoute: () => DashboardCampaignsUuidRouteRoute,
  } as any)
const DashboardAnnuairePeopleUuidRoute =
  DashboardAnnuairePeopleUuidRouteImport.update({
    id: '/annuaire/people/$uuid',
    path: '/annuaire/people/$uuid',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardAnnuaireOrganizationsUuidRoute =
  DashboardAnnuaireOrganizationsUuidRouteImport.update({
    id: '/annuaire/organizations/$uuid',
    path: '/annuaire/organizations/$uuid',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardHrdFormulairesUuidRouteRoute =
  DashboardHrdFormulairesUuidRouteRouteImport.update({
    id: '/$uuid',
    path: '/$uuid',
    getParentRoute: () => DashboardHrdFormulairesRouteRoute,
  } as any)
const DashboardHrdFormulairesUuidTabRoute =
  DashboardHrdFormulairesUuidTabRouteImport.update({
    id: '/$tab',
    path: '/$tab',
    getParentRoute: () => DashboardHrdFormulairesUuidRouteRoute,
  } as any)
const DashboardModulesUuidParticipationsParticipationUuidRouteRoute =
  DashboardModulesUuidParticipationsParticipationUuidRouteRouteImport.update({
    id: '/participations/$participationUuid',
    path: '/participations/$participationUuid',
    getParentRoute: () => DashboardModulesUuidRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/unauthorized': typeof UnauthorizedRoute
  '/campaigns': typeof DashboardCampaignsRouteRouteWithChildren
  '/hrd': typeof DashboardHrdRouteRouteWithChildren
  '/modules': typeof DashboardModulesRouteRouteWithChildren
  '/participations': typeof DashboardParticipationsRouteRouteWithChildren
  '/showcase/': typeof ShowcaseIndexRoute
  '/campaigns/$uuid': typeof DashboardCampaignsUuidRouteRouteWithChildren
  '/hrd/formulaires': typeof DashboardHrdFormulairesRouteRouteWithChildren
  '/modules/$uuid': typeof DashboardModulesUuidRouteRouteWithChildren
  '/participations/$uuid': typeof DashboardParticipationsUuidRouteRouteWithChildren
  '/annuaire/$tab': typeof DashboardAnnuaireTabRoute
  '/hrd/laboratories': typeof DashboardHrdLaboratoriesRoute
  '/preferences/flags': typeof DashboardPreferencesFlagsRoute
  '/preferences/programs': typeof DashboardPreferencesProgramsRoute
  '/annuaire/': typeof DashboardAnnuaireIndexRoute
  '/campaigns/': typeof DashboardCampaignsIndexRoute
  '/certificats/': typeof DashboardCertificatsIndexRoute
  '/modules/': typeof DashboardModulesIndexRoute
  '/participations-laboratoire/': typeof DashboardParticipationsLaboratoireIndexRoute
  '/participations/': typeof DashboardParticipationsIndexRoute
  '/forgot-password/': typeof PublicForgotPasswordIndexRoute
  '/reset-password/': typeof PublicResetPasswordIndexRoute
  '/hrd/formulaires/$uuid': typeof DashboardHrdFormulairesUuidRouteRouteWithChildren
  '/annuaire/organizations/$uuid': typeof DashboardAnnuaireOrganizationsUuidRoute
  '/annuaire/people/$uuid': typeof DashboardAnnuairePeopleUuidRoute
  '/campaigns/$uuid/$tab': typeof DashboardCampaignsUuidTabRoute
  '/hrd/cas/$uuid': typeof DashboardHrdCasUuidRoute
  '/modules/$uuid/$tab': typeof DashboardModulesUuidTabRoute
  '/participations/$uuid/$tab': typeof DashboardParticipationsUuidTabRoute
  '/hrd/cas/': typeof DashboardHrdCasIndexRoute
  '/hrd/formulaires/': typeof DashboardHrdFormulairesIndexRoute
  '/participations/$uuid/': typeof DashboardParticipationsUuidIndexRoute
  '/modules/$uuid/participations/$participationUuid': typeof DashboardModulesUuidParticipationsParticipationUuidRouteRoute
  '/hrd/formulaires/$uuid/$tab': typeof DashboardHrdFormulairesUuidTabRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/unauthorized': typeof UnauthorizedRoute
  '/hrd': typeof DashboardHrdRouteRouteWithChildren
  '/showcase': typeof ShowcaseIndexRoute
  '/campaigns/$uuid': typeof DashboardCampaignsUuidRouteRouteWithChildren
  '/modules/$uuid': typeof DashboardModulesUuidRouteRouteWithChildren
  '/annuaire/$tab': typeof DashboardAnnuaireTabRoute
  '/hrd/laboratories': typeof DashboardHrdLaboratoriesRoute
  '/preferences/flags': typeof DashboardPreferencesFlagsRoute
  '/preferences/programs': typeof DashboardPreferencesProgramsRoute
  '/annuaire': typeof DashboardAnnuaireIndexRoute
  '/campaigns': typeof DashboardCampaignsIndexRoute
  '/certificats': typeof DashboardCertificatsIndexRoute
  '/modules': typeof DashboardModulesIndexRoute
  '/participations-laboratoire': typeof DashboardParticipationsLaboratoireIndexRoute
  '/participations': typeof DashboardParticipationsIndexRoute
  '/forgot-password': typeof PublicForgotPasswordIndexRoute
  '/reset-password': typeof PublicResetPasswordIndexRoute
  '/hrd/formulaires/$uuid': typeof DashboardHrdFormulairesUuidRouteRouteWithChildren
  '/annuaire/organizations/$uuid': typeof DashboardAnnuaireOrganizationsUuidRoute
  '/annuaire/people/$uuid': typeof DashboardAnnuairePeopleUuidRoute
  '/campaigns/$uuid/$tab': typeof DashboardCampaignsUuidTabRoute
  '/hrd/cas/$uuid': typeof DashboardHrdCasUuidRoute
  '/modules/$uuid/$tab': typeof DashboardModulesUuidTabRoute
  '/participations/$uuid/$tab': typeof DashboardParticipationsUuidTabRoute
  '/hrd/cas': typeof DashboardHrdCasIndexRoute
  '/hrd/formulaires': typeof DashboardHrdFormulairesIndexRoute
  '/participations/$uuid': typeof DashboardParticipationsUuidIndexRoute
  '/modules/$uuid/participations/$participationUuid': typeof DashboardModulesUuidParticipationsParticipationUuidRouteRoute
  '/hrd/formulaires/$uuid/$tab': typeof DashboardHrdFormulairesUuidTabRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_dashboard': typeof DashboardRouteRouteWithChildren
  '/login': typeof LoginRoute
  '/unauthorized': typeof UnauthorizedRoute
  '/_dashboard/campaigns': typeof DashboardCampaignsRouteRouteWithChildren
  '/_dashboard/hrd': typeof DashboardHrdRouteRouteWithChildren
  '/_dashboard/modules': typeof DashboardModulesRouteRouteWithChildren
  '/_dashboard/participations': typeof DashboardParticipationsRouteRouteWithChildren
  '/showcase/': typeof ShowcaseIndexRoute
  '/_dashboard/campaigns/$uuid': typeof DashboardCampaignsUuidRouteRouteWithChildren
  '/_dashboard/hrd/formulaires': typeof DashboardHrdFormulairesRouteRouteWithChildren
  '/_dashboard/modules/$uuid': typeof DashboardModulesUuidRouteRouteWithChildren
  '/_dashboard/participations/$uuid': typeof DashboardParticipationsUuidRouteRouteWithChildren
  '/_dashboard/annuaire/$tab': typeof DashboardAnnuaireTabRoute
  '/_dashboard/hrd/laboratories': typeof DashboardHrdLaboratoriesRoute
  '/_dashboard/preferences/flags': typeof DashboardPreferencesFlagsRoute
  '/_dashboard/preferences/programs': typeof DashboardPreferencesProgramsRoute
  '/_dashboard/annuaire/': typeof DashboardAnnuaireIndexRoute
  '/_dashboard/campaigns/': typeof DashboardCampaignsIndexRoute
  '/_dashboard/certificats/': typeof DashboardCertificatsIndexRoute
  '/_dashboard/modules/': typeof DashboardModulesIndexRoute
  '/_dashboard/participations-laboratoire/': typeof DashboardParticipationsLaboratoireIndexRoute
  '/_dashboard/participations/': typeof DashboardParticipationsIndexRoute
  '/_public/forgot-password/': typeof PublicForgotPasswordIndexRoute
  '/_public/reset-password/': typeof PublicResetPasswordIndexRoute
  '/_dashboard/hrd/formulaires/$uuid': typeof DashboardHrdFormulairesUuidRouteRouteWithChildren
  '/_dashboard/annuaire/organizations/$uuid': typeof DashboardAnnuaireOrganizationsUuidRoute
  '/_dashboard/annuaire/people/$uuid': typeof DashboardAnnuairePeopleUuidRoute
  '/_dashboard/campaigns/$uuid/$tab': typeof DashboardCampaignsUuidTabRoute
  '/_dashboard/hrd/cas/$uuid': typeof DashboardHrdCasUuidRoute
  '/_dashboard/modules/$uuid/$tab': typeof DashboardModulesUuidTabRoute
  '/_dashboard/participations/$uuid/$tab': typeof DashboardParticipationsUuidTabRoute
  '/_dashboard/hrd/cas/': typeof DashboardHrdCasIndexRoute
  '/_dashboard/hrd/formulaires/': typeof DashboardHrdFormulairesIndexRoute
  '/_dashboard/participations/$uuid/': typeof DashboardParticipationsUuidIndexRoute
  '/_dashboard/modules/$uuid/participations/$participationUuid': typeof DashboardModulesUuidParticipationsParticipationUuidRouteRoute
  '/_dashboard/hrd/formulaires/$uuid/$tab': typeof DashboardHrdFormulairesUuidTabRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/unauthorized'
    | '/campaigns'
    | '/hrd'
    | '/modules'
    | '/participations'
    | '/showcase/'
    | '/campaigns/$uuid'
    | '/hrd/formulaires'
    | '/modules/$uuid'
    | '/participations/$uuid'
    | '/annuaire/$tab'
    | '/hrd/laboratories'
    | '/preferences/flags'
    | '/preferences/programs'
    | '/annuaire/'
    | '/campaigns/'
    | '/certificats/'
    | '/modules/'
    | '/participations-laboratoire/'
    | '/participations/'
    | '/forgot-password/'
    | '/reset-password/'
    | '/hrd/formulaires/$uuid'
    | '/annuaire/organizations/$uuid'
    | '/annuaire/people/$uuid'
    | '/campaigns/$uuid/$tab'
    | '/hrd/cas/$uuid'
    | '/modules/$uuid/$tab'
    | '/participations/$uuid/$tab'
    | '/hrd/cas/'
    | '/hrd/formulaires/'
    | '/participations/$uuid/'
    | '/modules/$uuid/participations/$participationUuid'
    | '/hrd/formulaires/$uuid/$tab'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/unauthorized'
    | '/hrd'
    | '/showcase'
    | '/campaigns/$uuid'
    | '/modules/$uuid'
    | '/annuaire/$tab'
    | '/hrd/laboratories'
    | '/preferences/flags'
    | '/preferences/programs'
    | '/annuaire'
    | '/campaigns'
    | '/certificats'
    | '/modules'
    | '/participations-laboratoire'
    | '/participations'
    | '/forgot-password'
    | '/reset-password'
    | '/hrd/formulaires/$uuid'
    | '/annuaire/organizations/$uuid'
    | '/annuaire/people/$uuid'
    | '/campaigns/$uuid/$tab'
    | '/hrd/cas/$uuid'
    | '/modules/$uuid/$tab'
    | '/participations/$uuid/$tab'
    | '/hrd/cas'
    | '/hrd/formulaires'
    | '/participations/$uuid'
    | '/modules/$uuid/participations/$participationUuid'
    | '/hrd/formulaires/$uuid/$tab'
  id:
    | '__root__'
    | '/'
    | '/_dashboard'
    | '/login'
    | '/unauthorized'
    | '/_dashboard/campaigns'
    | '/_dashboard/hrd'
    | '/_dashboard/modules'
    | '/_dashboard/participations'
    | '/showcase/'
    | '/_dashboard/campaigns/$uuid'
    | '/_dashboard/hrd/formulaires'
    | '/_dashboard/modules/$uuid'
    | '/_dashboard/participations/$uuid'
    | '/_dashboard/annuaire/$tab'
    | '/_dashboard/hrd/laboratories'
    | '/_dashboard/preferences/flags'
    | '/_dashboard/preferences/programs'
    | '/_dashboard/annuaire/'
    | '/_dashboard/campaigns/'
    | '/_dashboard/certificats/'
    | '/_dashboard/modules/'
    | '/_dashboard/participations-laboratoire/'
    | '/_dashboard/participations/'
    | '/_public/forgot-password/'
    | '/_public/reset-password/'
    | '/_dashboard/hrd/formulaires/$uuid'
    | '/_dashboard/annuaire/organizations/$uuid'
    | '/_dashboard/annuaire/people/$uuid'
    | '/_dashboard/campaigns/$uuid/$tab'
    | '/_dashboard/hrd/cas/$uuid'
    | '/_dashboard/modules/$uuid/$tab'
    | '/_dashboard/participations/$uuid/$tab'
    | '/_dashboard/hrd/cas/'
    | '/_dashboard/hrd/formulaires/'
    | '/_dashboard/participations/$uuid/'
    | '/_dashboard/modules/$uuid/participations/$participationUuid'
    | '/_dashboard/hrd/formulaires/$uuid/$tab'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  DashboardRouteRoute: typeof DashboardRouteRouteWithChildren
  LoginRoute: typeof LoginRoute
  UnauthorizedRoute: typeof UnauthorizedRoute
  ShowcaseIndexRoute: typeof ShowcaseIndexRoute
  PublicForgotPasswordIndexRoute: typeof PublicForgotPasswordIndexRoute
  PublicResetPasswordIndexRoute: typeof PublicResetPasswordIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/unauthorized': {
      id: '/unauthorized'
      path: '/unauthorized'
      fullPath: '/unauthorized'
      preLoaderRoute: typeof UnauthorizedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_dashboard': {
      id: '/_dashboard'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof DashboardRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/showcase/': {
      id: '/showcase/'
      path: '/showcase'
      fullPath: '/showcase/'
      preLoaderRoute: typeof ShowcaseIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_dashboard/participations': {
      id: '/_dashboard/participations'
      path: '/participations'
      fullPath: '/participations'
      preLoaderRoute: typeof DashboardParticipationsRouteRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/_dashboard/modules': {
      id: '/_dashboard/modules'
      path: '/modules'
      fullPath: '/modules'
      preLoaderRoute: typeof DashboardModulesRouteRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/_dashboard/hrd': {
      id: '/_dashboard/hrd'
      path: '/hrd'
      fullPath: '/hrd'
      preLoaderRoute: typeof DashboardHrdRouteRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/_dashboard/campaigns': {
      id: '/_dashboard/campaigns'
      path: '/campaigns'
      fullPath: '/campaigns'
      preLoaderRoute: typeof DashboardCampaignsRouteRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/_public/reset-password/': {
      id: '/_public/reset-password/'
      path: '/reset-password'
      fullPath: '/reset-password/'
      preLoaderRoute: typeof PublicResetPasswordIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_public/forgot-password/': {
      id: '/_public/forgot-password/'
      path: '/forgot-password'
      fullPath: '/forgot-password/'
      preLoaderRoute: typeof PublicForgotPasswordIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_dashboard/participations/': {
      id: '/_dashboard/participations/'
      path: '/'
      fullPath: '/participations/'
      preLoaderRoute: typeof DashboardParticipationsIndexRouteImport
      parentRoute: typeof DashboardParticipationsRouteRoute
    }
    '/_dashboard/participations-laboratoire/': {
      id: '/_dashboard/participations-laboratoire/'
      path: '/participations-laboratoire'
      fullPath: '/participations-laboratoire/'
      preLoaderRoute: typeof DashboardParticipationsLaboratoireIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/_dashboard/modules/': {
      id: '/_dashboard/modules/'
      path: '/'
      fullPath: '/modules/'
      preLoaderRoute: typeof DashboardModulesIndexRouteImport
      parentRoute: typeof DashboardModulesRouteRoute
    }
    '/_dashboard/certificats/': {
      id: '/_dashboard/certificats/'
      path: '/certificats'
      fullPath: '/certificats/'
      preLoaderRoute: typeof DashboardCertificatsIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/_dashboard/campaigns/': {
      id: '/_dashboard/campaigns/'
      path: '/'
      fullPath: '/campaigns/'
      preLoaderRoute: typeof DashboardCampaignsIndexRouteImport
      parentRoute: typeof DashboardCampaignsRouteRoute
    }
    '/_dashboard/annuaire/': {
      id: '/_dashboard/annuaire/'
      path: '/annuaire'
      fullPath: '/annuaire/'
      preLoaderRoute: typeof DashboardAnnuaireIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/_dashboard/preferences/programs': {
      id: '/_dashboard/preferences/programs'
      path: '/preferences/programs'
      fullPath: '/preferences/programs'
      preLoaderRoute: typeof DashboardPreferencesProgramsRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/_dashboard/preferences/flags': {
      id: '/_dashboard/preferences/flags'
      path: '/preferences/flags'
      fullPath: '/preferences/flags'
      preLoaderRoute: typeof DashboardPreferencesFlagsRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/_dashboard/hrd/laboratories': {
      id: '/_dashboard/hrd/laboratories'
      path: '/laboratories'
      fullPath: '/hrd/laboratories'
      preLoaderRoute: typeof DashboardHrdLaboratoriesRouteImport
      parentRoute: typeof DashboardHrdRouteRoute
    }
    '/_dashboard/annuaire/$tab': {
      id: '/_dashboard/annuaire/$tab'
      path: '/annuaire/$tab'
      fullPath: '/annuaire/$tab'
      preLoaderRoute: typeof DashboardAnnuaireTabRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/_dashboard/participations/$uuid': {
      id: '/_dashboard/participations/$uuid'
      path: '/$uuid'
      fullPath: '/participations/$uuid'
      preLoaderRoute: typeof DashboardParticipationsUuidRouteRouteImport
      parentRoute: typeof DashboardParticipationsRouteRoute
    }
    '/_dashboard/modules/$uuid': {
      id: '/_dashboard/modules/$uuid'
      path: '/$uuid'
      fullPath: '/modules/$uuid'
      preLoaderRoute: typeof DashboardModulesUuidRouteRouteImport
      parentRoute: typeof DashboardModulesRouteRoute
    }
    '/_dashboard/hrd/formulaires': {
      id: '/_dashboard/hrd/formulaires'
      path: '/formulaires'
      fullPath: '/hrd/formulaires'
      preLoaderRoute: typeof DashboardHrdFormulairesRouteRouteImport
      parentRoute: typeof DashboardHrdRouteRoute
    }
    '/_dashboard/campaigns/$uuid': {
      id: '/_dashboard/campaigns/$uuid'
      path: '/$uuid'
      fullPath: '/campaigns/$uuid'
      preLoaderRoute: typeof DashboardCampaignsUuidRouteRouteImport
      parentRoute: typeof DashboardCampaignsRouteRoute
    }
    '/_dashboard/participations/$uuid/': {
      id: '/_dashboard/participations/$uuid/'
      path: '/'
      fullPath: '/participations/$uuid/'
      preLoaderRoute: typeof DashboardParticipationsUuidIndexRouteImport
      parentRoute: typeof DashboardParticipationsUuidRouteRoute
    }
    '/_dashboard/hrd/formulaires/': {
      id: '/_dashboard/hrd/formulaires/'
      path: '/'
      fullPath: '/hrd/formulaires/'
      preLoaderRoute: typeof DashboardHrdFormulairesIndexRouteImport
      parentRoute: typeof DashboardHrdFormulairesRouteRoute
    }
    '/_dashboard/hrd/cas/': {
      id: '/_dashboard/hrd/cas/'
      path: '/cas'
      fullPath: '/hrd/cas/'
      preLoaderRoute: typeof DashboardHrdCasIndexRouteImport
      parentRoute: typeof DashboardHrdRouteRoute
    }
    '/_dashboard/participations/$uuid/$tab': {
      id: '/_dashboard/participations/$uuid/$tab'
      path: '/$tab'
      fullPath: '/participations/$uuid/$tab'
      preLoaderRoute: typeof DashboardParticipationsUuidTabRouteImport
      parentRoute: typeof DashboardParticipationsUuidRouteRoute
    }
    '/_dashboard/modules/$uuid/$tab': {
      id: '/_dashboard/modules/$uuid/$tab'
      path: '/$tab'
      fullPath: '/modules/$uuid/$tab'
      preLoaderRoute: typeof DashboardModulesUuidTabRouteImport
      parentRoute: typeof DashboardModulesUuidRouteRoute
    }
    '/_dashboard/hrd/cas/$uuid': {
      id: '/_dashboard/hrd/cas/$uuid'
      path: '/cas/$uuid'
      fullPath: '/hrd/cas/$uuid'
      preLoaderRoute: typeof DashboardHrdCasUuidRouteImport
      parentRoute: typeof DashboardHrdRouteRoute
    }
    '/_dashboard/campaigns/$uuid/$tab': {
      id: '/_dashboard/campaigns/$uuid/$tab'
      path: '/$tab'
      fullPath: '/campaigns/$uuid/$tab'
      preLoaderRoute: typeof DashboardCampaignsUuidTabRouteImport
      parentRoute: typeof DashboardCampaignsUuidRouteRoute
    }
    '/_dashboard/annuaire/people/$uuid': {
      id: '/_dashboard/annuaire/people/$uuid'
      path: '/annuaire/people/$uuid'
      fullPath: '/annuaire/people/$uuid'
      preLoaderRoute: typeof DashboardAnnuairePeopleUuidRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/_dashboard/annuaire/organizations/$uuid': {
      id: '/_dashboard/annuaire/organizations/$uuid'
      path: '/annuaire/organizations/$uuid'
      fullPath: '/annuaire/organizations/$uuid'
      preLoaderRoute: typeof DashboardAnnuaireOrganizationsUuidRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/_dashboard/hrd/formulaires/$uuid': {
      id: '/_dashboard/hrd/formulaires/$uuid'
      path: '/$uuid'
      fullPath: '/hrd/formulaires/$uuid'
      preLoaderRoute: typeof DashboardHrdFormulairesUuidRouteRouteImport
      parentRoute: typeof DashboardHrdFormulairesRouteRoute
    }
    '/_dashboard/hrd/formulaires/$uuid/$tab': {
      id: '/_dashboard/hrd/formulaires/$uuid/$tab'
      path: '/$tab'
      fullPath: '/hrd/formulaires/$uuid/$tab'
      preLoaderRoute: typeof DashboardHrdFormulairesUuidTabRouteImport
      parentRoute: typeof DashboardHrdFormulairesUuidRouteRoute
    }
    '/_dashboard/modules/$uuid/participations/$participationUuid': {
      id: '/_dashboard/modules/$uuid/participations/$participationUuid'
      path: '/participations/$participationUuid'
      fullPath: '/modules/$uuid/participations/$participationUuid'
      preLoaderRoute: typeof DashboardModulesUuidParticipationsParticipationUuidRouteRouteImport
      parentRoute: typeof DashboardModulesUuidRouteRoute
    }
  }
}

interface DashboardCampaignsUuidRouteRouteChildren {
  DashboardCampaignsUuidTabRoute: typeof DashboardCampaignsUuidTabRoute
}

const DashboardCampaignsUuidRouteRouteChildren: DashboardCampaignsUuidRouteRouteChildren =
  {
    DashboardCampaignsUuidTabRoute: DashboardCampaignsUuidTabRoute,
  }

const DashboardCampaignsUuidRouteRouteWithChildren =
  DashboardCampaignsUuidRouteRoute._addFileChildren(
    DashboardCampaignsUuidRouteRouteChildren,
  )

interface DashboardCampaignsRouteRouteChildren {
  DashboardCampaignsUuidRouteRoute: typeof DashboardCampaignsUuidRouteRouteWithChildren
  DashboardCampaignsIndexRoute: typeof DashboardCampaignsIndexRoute
}

const DashboardCampaignsRouteRouteChildren: DashboardCampaignsRouteRouteChildren =
  {
    DashboardCampaignsUuidRouteRoute:
      DashboardCampaignsUuidRouteRouteWithChildren,
    DashboardCampaignsIndexRoute: DashboardCampaignsIndexRoute,
  }

const DashboardCampaignsRouteRouteWithChildren =
  DashboardCampaignsRouteRoute._addFileChildren(
    DashboardCampaignsRouteRouteChildren,
  )

interface DashboardHrdFormulairesUuidRouteRouteChildren {
  DashboardHrdFormulairesUuidTabRoute: typeof DashboardHrdFormulairesUuidTabRoute
}

const DashboardHrdFormulairesUuidRouteRouteChildren: DashboardHrdFormulairesUuidRouteRouteChildren =
  {
    DashboardHrdFormulairesUuidTabRoute: DashboardHrdFormulairesUuidTabRoute,
  }

const DashboardHrdFormulairesUuidRouteRouteWithChildren =
  DashboardHrdFormulairesUuidRouteRoute._addFileChildren(
    DashboardHrdFormulairesUuidRouteRouteChildren,
  )

interface DashboardHrdFormulairesRouteRouteChildren {
  DashboardHrdFormulairesUuidRouteRoute: typeof DashboardHrdFormulairesUuidRouteRouteWithChildren
  DashboardHrdFormulairesIndexRoute: typeof DashboardHrdFormulairesIndexRoute
}

const DashboardHrdFormulairesRouteRouteChildren: DashboardHrdFormulairesRouteRouteChildren =
  {
    DashboardHrdFormulairesUuidRouteRoute:
      DashboardHrdFormulairesUuidRouteRouteWithChildren,
    DashboardHrdFormulairesIndexRoute: DashboardHrdFormulairesIndexRoute,
  }

const DashboardHrdFormulairesRouteRouteWithChildren =
  DashboardHrdFormulairesRouteRoute._addFileChildren(
    DashboardHrdFormulairesRouteRouteChildren,
  )

interface DashboardHrdRouteRouteChildren {
  DashboardHrdFormulairesRouteRoute: typeof DashboardHrdFormulairesRouteRouteWithChildren
  DashboardHrdLaboratoriesRoute: typeof DashboardHrdLaboratoriesRoute
  DashboardHrdCasUuidRoute: typeof DashboardHrdCasUuidRoute
  DashboardHrdCasIndexRoute: typeof DashboardHrdCasIndexRoute
}

const DashboardHrdRouteRouteChildren: DashboardHrdRouteRouteChildren = {
  DashboardHrdFormulairesRouteRoute:
    DashboardHrdFormulairesRouteRouteWithChildren,
  DashboardHrdLaboratoriesRoute: DashboardHrdLaboratoriesRoute,
  DashboardHrdCasUuidRoute: DashboardHrdCasUuidRoute,
  DashboardHrdCasIndexRoute: DashboardHrdCasIndexRoute,
}

const DashboardHrdRouteRouteWithChildren =
  DashboardHrdRouteRoute._addFileChildren(DashboardHrdRouteRouteChildren)

interface DashboardModulesUuidRouteRouteChildren {
  DashboardModulesUuidTabRoute: typeof DashboardModulesUuidTabRoute
  DashboardModulesUuidParticipationsParticipationUuidRouteRoute: typeof DashboardModulesUuidParticipationsParticipationUuidRouteRoute
}

const DashboardModulesUuidRouteRouteChildren: DashboardModulesUuidRouteRouteChildren =
  {
    DashboardModulesUuidTabRoute: DashboardModulesUuidTabRoute,
    DashboardModulesUuidParticipationsParticipationUuidRouteRoute:
      DashboardModulesUuidParticipationsParticipationUuidRouteRoute,
  }

const DashboardModulesUuidRouteRouteWithChildren =
  DashboardModulesUuidRouteRoute._addFileChildren(
    DashboardModulesUuidRouteRouteChildren,
  )

interface DashboardModulesRouteRouteChildren {
  DashboardModulesUuidRouteRoute: typeof DashboardModulesUuidRouteRouteWithChildren
  DashboardModulesIndexRoute: typeof DashboardModulesIndexRoute
}

const DashboardModulesRouteRouteChildren: DashboardModulesRouteRouteChildren = {
  DashboardModulesUuidRouteRoute: DashboardModulesUuidRouteRouteWithChildren,
  DashboardModulesIndexRoute: DashboardModulesIndexRoute,
}

const DashboardModulesRouteRouteWithChildren =
  DashboardModulesRouteRoute._addFileChildren(
    DashboardModulesRouteRouteChildren,
  )

interface DashboardParticipationsUuidRouteRouteChildren {
  DashboardParticipationsUuidTabRoute: typeof DashboardParticipationsUuidTabRoute
  DashboardParticipationsUuidIndexRoute: typeof DashboardParticipationsUuidIndexRoute
}

const DashboardParticipationsUuidRouteRouteChildren: DashboardParticipationsUuidRouteRouteChildren =
  {
    DashboardParticipationsUuidTabRoute: DashboardParticipationsUuidTabRoute,
    DashboardParticipationsUuidIndexRoute:
      DashboardParticipationsUuidIndexRoute,
  }

const DashboardParticipationsUuidRouteRouteWithChildren =
  DashboardParticipationsUuidRouteRoute._addFileChildren(
    DashboardParticipationsUuidRouteRouteChildren,
  )

interface DashboardParticipationsRouteRouteChildren {
  DashboardParticipationsUuidRouteRoute: typeof DashboardParticipationsUuidRouteRouteWithChildren
  DashboardParticipationsIndexRoute: typeof DashboardParticipationsIndexRoute
}

const DashboardParticipationsRouteRouteChildren: DashboardParticipationsRouteRouteChildren =
  {
    DashboardParticipationsUuidRouteRoute:
      DashboardParticipationsUuidRouteRouteWithChildren,
    DashboardParticipationsIndexRoute: DashboardParticipationsIndexRoute,
  }

const DashboardParticipationsRouteRouteWithChildren =
  DashboardParticipationsRouteRoute._addFileChildren(
    DashboardParticipationsRouteRouteChildren,
  )

interface DashboardRouteRouteChildren {
  DashboardCampaignsRouteRoute: typeof DashboardCampaignsRouteRouteWithChildren
  DashboardHrdRouteRoute: typeof DashboardHrdRouteRouteWithChildren
  DashboardModulesRouteRoute: typeof DashboardModulesRouteRouteWithChildren
  DashboardParticipationsRouteRoute: typeof DashboardParticipationsRouteRouteWithChildren
  DashboardAnnuaireTabRoute: typeof DashboardAnnuaireTabRoute
  DashboardPreferencesFlagsRoute: typeof DashboardPreferencesFlagsRoute
  DashboardPreferencesProgramsRoute: typeof DashboardPreferencesProgramsRoute
  DashboardAnnuaireIndexRoute: typeof DashboardAnnuaireIndexRoute
  DashboardCertificatsIndexRoute: typeof DashboardCertificatsIndexRoute
  DashboardParticipationsLaboratoireIndexRoute: typeof DashboardParticipationsLaboratoireIndexRoute
  DashboardAnnuaireOrganizationsUuidRoute: typeof DashboardAnnuaireOrganizationsUuidRoute
  DashboardAnnuairePeopleUuidRoute: typeof DashboardAnnuairePeopleUuidRoute
}

const DashboardRouteRouteChildren: DashboardRouteRouteChildren = {
  DashboardCampaignsRouteRoute: DashboardCampaignsRouteRouteWithChildren,
  DashboardHrdRouteRoute: DashboardHrdRouteRouteWithChildren,
  DashboardModulesRouteRoute: DashboardModulesRouteRouteWithChildren,
  DashboardParticipationsRouteRoute:
    DashboardParticipationsRouteRouteWithChildren,
  DashboardAnnuaireTabRoute: DashboardAnnuaireTabRoute,
  DashboardPreferencesFlagsRoute: DashboardPreferencesFlagsRoute,
  DashboardPreferencesProgramsRoute: DashboardPreferencesProgramsRoute,
  DashboardAnnuaireIndexRoute: DashboardAnnuaireIndexRoute,
  DashboardCertificatsIndexRoute: DashboardCertificatsIndexRoute,
  DashboardParticipationsLaboratoireIndexRoute:
    DashboardParticipationsLaboratoireIndexRoute,
  DashboardAnnuaireOrganizationsUuidRoute:
    DashboardAnnuaireOrganizationsUuidRoute,
  DashboardAnnuairePeopleUuidRoute: DashboardAnnuairePeopleUuidRoute,
}

const DashboardRouteRouteWithChildren = DashboardRouteRoute._addFileChildren(
  DashboardRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  DashboardRouteRoute: DashboardRouteRouteWithChildren,
  LoginRoute: LoginRoute,
  UnauthorizedRoute: UnauthorizedRoute,
  ShowcaseIndexRoute: ShowcaseIndexRoute,
  PublicForgotPasswordIndexRoute: PublicForgotPasswordIndexRoute,
  PublicResetPasswordIndexRoute: PublicResetPasswordIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
